module.exports = __webpack_public_path__ + "static/media/mkj.62aa876c.jpg";